

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { InstalledApp, AppConfigViewModel } from '@/features/apps/shared/models';
import CapableAppSelection from './CapableAppSelection.vue';
import CapableAppConfig from './CapableAppConfig.vue';
import { ConfigRequest } from './configRequest';

@Component({
	components: {
		CapableAppSelection,
		CapableAppConfig
	}
})
export default class CapableAppModal extends Vue {
	@Prop() public capableApps: InstalledApp[];
	@Prop() public configRequest: ConfigRequest;
	@Prop() public modalHeading: string;
	public currentApp: InstalledApp | null = null;

	public getTitle() {
		if (this.currentApp) {
			return this.currentApp.name;
		}
		return this.modalHeading;
	}

	public getSubtitle() {
		if (this.currentApp) {
			if (this.currentApp.description) {
				return this.currentApp.description;
			}
			return 'Private app';
		}
		return 'Select from your installed apps';
	}

	public getIcon() {
		if (!this.currentApp) {
			return { type: 'fontawesome', icon: 'cubes' };
		}
		if (this.currentApp.icon) {
			return { type: 'svg', icon: this.currentApp.icon };
		}
		return { type: 'fontawesome', icon: 'code' };
	}

	public close() {
		this.$emit('close');
	}

	public onAppSelected(app: InstalledApp) {
		if (app.hasConfigUrl) {
			this.currentApp = app;
		} else {
			this.complete(app.installedAppId, {});
		}
	}

	public complete(installedAppId: string, config: any) {
		this.$emit('completed', installedAppId, config);
		this.close();
	}
}
